import { METHOD } from 'services/method'

export const API_PARTNERSHIP = {
    LIST: {
        api: '/v1/dashboard-admin/partnership/list',
        method: METHOD.POST,
    },
    UPDATE_STATUS: {
        api: '/v1/dashboard-admin/partnership/status',
        method: METHOD.PUT,
    },
    EXPORT: {
        api: '/v1/dashboard-admin/partnership/list/export',
        method: METHOD.POST,
    },
}
